import React, {PureComponent} from "react"

import {FormattedMessage} from "@irati/utils/lang"
import id from "@irati/utils/id"
import {Label} from "@irati/ui/src/Typography"

interface Props {
  message: string,
  tenantName?: string
}

class WalletIntroText extends PureComponent<Props> {
  render() {
    const {message, tenantName} = this.props
    const idNamespace = id("intro", this.props)

    return (
      <Label id={idNamespace} large display="block" marginTop={3} marginBottom>
        {tenantName
          ? <FormattedMessage id={message} values={{tenantName}} />
          : <FormattedMessage id={message} />
        }
      </Label>
    )
  }
}

export default WalletIntroText
